'use client';

import { type MouseEventHandler, forwardRef, useCallback, useContext } from 'react';

import { Slot } from '../slot';
import { ModalRootContext } from './context/modal-root.context';
import type { ModalClosePropsInterface } from './types/modal-close.types';

/**
 * @since 10.0.0
 */
export const ModalClose = forwardRef<HTMLButtonElement, ModalClosePropsInterface>(
  (props: ModalClosePropsInterface, forwardedRef) => {
    const { children, onClick, ...rest } = props;
    const { modal } = useContext(ModalRootContext);

    const onClickHandler = useCallback<MouseEventHandler<HTMLButtonElement>>(
      (event) => {
        modal.onClickClose(event);
        onClick?.(event);
      },
      [modal, onClick],
    );

    return (
      <Slot
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Modal.Close"
        {...rest}
        onClick={onClickHandler}
      >
        {children}
      </Slot>
    );
  },
);

ModalClose.displayName = 'Modal.Close';
